<template>
	<b-modal id="account-versions" size="lg" title="Versions" hide-footer no-fade v-model="show" @show="listVersions">
		<div v-if="loading" class="text-center">
			<p><font-awesome-icon icon="spinner" pulse /> Loading...</p>
		</div>
		<div v-else-if="versions.length == 0">
			<p>Odd. This character doesn't have any previous versions.</p>
		</div>
		<b-table-simple responsive striped v-else>
			<b-thead>
				<b-tr>
					<b-th>Version</b-th>
					<b-th>Date</b-th>
					<b-th>Short Description</b-th>
					<b-th></b-th>
				</b-tr>
			</b-thead>
			<b-tbody>
				<b-tr v-for="(version, versionIndex) in versions" :key="versionIndex">
					<b-td>{{version.version}}</b-td>
					<b-td>{{formatDate(version.data)}}</b-td>
					<b-td>{{version.desc}}</b-td>
					<b-td>
						<button class="btn btn-sm btn-secondary" @click="loadVersion(version.version)">Inspect</button>
						<button class="btn btn-sm btn-primary" @click="recoverCharacter(version.version)">Recover</button>
					</b-td>
				</b-tr>
			</b-tbody>
		</b-table-simple>
	</b-modal>
</template>

<script>
import Axios from "axios"
var moment = require('moment');


export default {
	data: function() {
		return {
			versions: [],
		}
	},
	computed: {
		show: {
			get: function(){
				return this.$store.state.characters.versions.show
			},
			set: function(){
				this.$store.dispatch('characters/hideVersions')
			}
		},
		loading: {
			get: function(){
				return this.$store.state.characters.versions.loading
			},
			set: function(value){
				this.$store.dispatch('characters/setVersionsLoading',value)
			}
		},
		character: {
			get: function(){
				return this.$store.state.characters.versions.character
			},
			set: function(value){
				this.$store.dispatch('characters/setCharacter',{
					id: value,
					version: 0,
				})
			}
		}
	},
	methods: {
		formatDate: function(value) {
            return moment(value+'Z','YYYYMMDD-kkmmssZ').format('L LTS');
		},
		listVersions: function() {
			this.loading = true
			Axios.get(`https://data.character.gallery/characters/${this.character.id}/versions`)
			.then( response => {
				this.versions = response.data.data
			})
			.finally( () => {
				this.loading = false
			})	
		},
		loadVersion: function(version) {
			this.$store.dispatch('characters/load', {
				character: this.character.id,
				version: version,
			})
			this.show = false
		},
		recoverCharacter: function(version) {
			this.$store.dispatch('characters/recover', {
				character: this.character.id,
				version: version,
			})
			this.show = false
		}
	}
}
</script>

<style scoped>

</style>